<template>
  <div class="d-flex flex-column align-items-center tw:min-w-0">
    <canvas ref="canvas" class="align-self-center w-100 h-100 tw:border tw:rounded-lg" v-bind="$attrs"></canvas>
    <div class="w-100 d-flex flex-column align-items-center tw:min-w-0 tw:mt-4">
      <code class="tw:w-full tw:break-all tw:text-center">
        {{ value }}
      </code>
      <button v-if="withDownload" @click="downloadQR" class="btn mt-3 btn-primary">
        <i class="fa fa-download"></i>
        {{ $t('Download') }}
      </button>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, defineProps } from 'vue'
import QRCodeGenerator from 'qrcode'

const canvas = ref(null)

const props = defineProps({
  value: {
    type: String,
    default: '',
  },
  options: {
    type: Object,
    default: () => ({}),
  },
  withDownload : {
    type: Boolean,
    default: false
  }
});

const generateQR = (text) => {
  const options = {
    errorCorrectionLevel: 'H',
    width: 256,
    ... props.options,
  }
  QRCodeGenerator.toCanvas(canvas.value, text, options, function (error) {
    if (error) console.error(error)
  })
}

const downloadQR = () => {
  // @source: https://fjolt.com/article/html-canvas-save-as-image/
  const link = document.createElement('a')
  link.download = 'qrcode.png'
  link.href = canvas.value.toDataURL()
  link.click()
  link.remove()
}

onMounted(() => {
    generateQR(props.value)
})
</script>
